import axios from "axios";

const API_URL = process.env.REACT_APP_URL_API_PROD;

export async function getCategorias() {
  console.log("Llamando a getCategorias"); // <-- Añade esto
  try {
    console.log("API_URL", API_URL);
    const response = await axios.get(`${API_URL}/products/categorias`);
    if (response.status !== 200) {
      throw new Error("Error al obtener las categorías");
    }
    getTipoCategorias(response.data[0]._id);
    return response.data;
  } catch (error) {
    console.error("Error al obtener las categorías:", error);
    throw error;
  }
}

async function getTipoCategorias(categoriaId) {
  try {
    console.log("API_URL", API_URL);
    const response = await axios.get(
      `${API_URL}/products/categorias/${categoriaId}/tipos-categorias`
    );
    if (response.status !== 200) {
      throw new Error("Error al obtener los tipos de categorías");
    }
    console.log("Tipos de categorías:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error al obtener los tipos de categorías:", error);
    throw error;
  }
}

// Obtiene todas las categorías con sus tipos de categorías hijos
export async function getCategoriasConTipos() {
  try {
    const response = await axios.get(`${API_URL}/products/categorias`);
    const categorias = response.data;

    // Para cada categoría, obtener sus tipos de categorías
    const categoriasConTipos = await Promise.all(
      categorias.map(async (categoria) => {
        const tiposResponse = await axios.get(
          `${API_URL}/products/categorias/${categoria._id}/tipos-categorias`
        );
        return {
          ...categoria,
          tiposCategorias: tiposResponse.data, // array de tipos de esa categoría
        };
      })
    );

    return categoriasConTipos;
  } catch (error) {
    console.error("Error al obtener categorías con tipos:", error);
    throw error;
  }
}

// Obtiene los productos de un tipo de categoría
async function getProductos(tipoCategoriaId) {
  try {
    const response = await axios.get(
      `${API_URL}/products/tipoCategoria/${tipoCategoriaId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener productos:", error);
    return [];
  }
}

// Obtiene todas las categorías con sus tipos de categorías y productos hijos
export async function getCategoriasConTiposYProductos() {
  try {
    const response = await axios.get(`${API_URL}/products/categorias`);
    const categorias = response.data;

    const categoriasConTiposYProductos = await Promise.all(
      categorias.map(async (categoria) => {
        const tiposResponse = await axios.get(
          `${API_URL}/products/categorias/${categoria._id}/tipos-categorias`
        );
        const tiposCategorias = await Promise.all(
          tiposResponse.data.map(async (tipo) => {
            const productos = await getProductos(tipo._id);
            return {
              ...tipo,
              productos, // array de productos de ese tipo
            };
          })
        );
        return {
          ...categoria,
          tiposCategorias,
        };
      })
    );

    return categoriasConTiposYProductos;
  } catch (error) {
    console.error("Error al obtener categorías con tipos y productos:", error);
    throw error;
  }
}
